import { AppLoader, Breadcrumb } from "@/components/ui";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useClerk, useOrganization, useUser } from "@clerk/react";
import { Outlet } from "@tanstack/react-router";
import React from "react";
import { AppHeader } from "./app-header";
import { AppSidebar } from "./app-sidebar";
import { NoOrg } from "./no-org";

export function AppLayout() {
  const { isLoaded: isUserLoaded, isSignedIn, user } = useUser();
  const { isLoaded: isOrgLoaded, organization } = useOrganization();
  const clerk = useClerk();

  const [open, setOpen] = React.useState(() => {
    const match = document.cookie.match(/(?:^|;\s*)sidebar_state=([^;]*)/);
    return match?.[1] === "true";
  });

  const firstMembershipOrgId = isUserLoaded && isSignedIn
    ? user.organizationMemberships[0]?.organization.id ?? null
    : null;

  React.useEffect(() => {
    if (!isUserLoaded || !isOrgLoaded || !isSignedIn) return;
    if (organization !== null) return;
    if (firstMembershipOrgId === null) return;
    void clerk.setActive({ organization: firstMembershipOrgId });
  }, [isUserLoaded, isOrgLoaded, isSignedIn, organization, firstMembershipOrgId, clerk]);

  if (!isUserLoaded || !isOrgLoaded) {
    return <AppLoader />;
  }

  if (!isSignedIn) {
    return null;
  }

  const hasOrgs = user.organizationMemberships.length > 0;

  if (!hasOrgs) {
    return <NoOrg />;
  }

  return (
    <SidebarProvider
      style={{
        "--sidebar-width": "15rem",
      } as React.CSSProperties}
      open={open}
      onOpenChange={setOpen}
    >
      <AppSidebar />

      <main className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Breadcrumb.Provider>
          <AppHeader />
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
            {organization === null
              ? <AppLoader />
              : (
                <div className="min-h-0 flex-1 overflow-auto">
                  <Outlet />
                </div>
              )}
          </div>
        </Breadcrumb.Provider>
      </main>
    </SidebarProvider>
  );
}
